import { Route } from '@angular/router';
import { ROUTE_PATH } from '../../routing/RoutePath.const';

export const authProcessPagesRoutes: Route[] = [
  {
    path: ROUTE_PATH.LOGIN,
    loadChildren: () =>
      import('./login-page/login-page.module').then((m) => m.LoginPageModule),
  },
  {
    path: ROUTE_PATH.LOGIN_SECRET_WITH_PIN,
    loadChildren: () =>
      import(
        './login-secret-with-pin-page/login-secret-with-pin-page.module'
      ).then((m) => m.LoginSecretWithPinPageModule),
  },
  {
    path: ROUTE_PATH.LOGIN_SECRET_WITH_PASSWORD,
    loadChildren: () =>
      import(
        './login-secret-with-password-page/login-secret-with-password-page.module'
      ).then((m) => m.LoginSecretWithPasswordPageModule),
  },
  {
    path: ROUTE_PATH.REGISTRATION_PERSONAL_DATA,
    loadChildren: () =>
      import(
        './register-personal-data-page/register-personal-data-page.module'
      ).then((m) => m.RegisterPersonalDataPageModule),
  },
  {
    path: ROUTE_PATH.REGISTRATION_SECRET_DATA,
    loadChildren: () =>
      import(
        './register-secret-data-page/register-secret-data-page.module'
      ).then((m) => m.RegisterSecretDataPageModule),
  },
  {
    path: ROUTE_PATH.REGISTRATION_PIN,
    loadChildren: () =>
      import('./register-pin-page/register-pin-page.module').then(
        (m) => m.RegisterPinPageModule
      ),
  },
  {
    path: ROUTE_PATH.REGISTRATION_SUCCESS,
    loadChildren: () =>
      import('./register-success-page/register-success-page.module').then(
        (m) => m.RegisterSuccessPageModule
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.LOGIN,
  },
];
